import { statuses } from "./state/statuses.js";

export const state = {
    statuses
};